module.exports = __webpack_public_path__ + "img/glyph-icon.1b78069c.svg";